<template>
    <div>
        <store-filter-link 
            :filterLayout="filterLayout"
            :filterData="filterSet.filter" 
            :paginationData="filterSet.page"
        ></store-filter-link>
        <store-list-link 
            :listLayout="listLayout" 
            :paginationData="filterSet.page" 
            :storeData="List"
        ></store-list-link>
        <pagination-link 
            :paginationLayout="paginationLayout" 
            :paginationData="filterSet.page"
            :listLength="List.length" 
            :type="storeType"
        ></pagination-link>
    </div>
</template>

<script>
    import StoreFilterLink from "@/components/store/link/StoreFilterLink";
    import StoreListLink from "@/components/store/link/StoreListLink";
    import PaginationLink from "@/components/store/link/PaginationLink";
    import filterMixins from "@/mixins/filterMixins";
    import listMixins from "@/mixins/listMixins";
    import alertMixins from "@/mixins/alertMixins";
    import EventBus from "@/utils/event-bus";
    import storeUtil from "@/components/store/StoreUtil";

    const {filterConfig} = storeUtil;

    export default {
        name: "StoreListComponent",
        mixins: [filterMixins, listMixins, alertMixins, storeUtil],
        components: {StoreFilterLink, StoreListLink, PaginationLink},
        provide() {
            return {
                setPage: this.setPage,
                setFilter: this.setFilter,
                storeListSetData: this.setData,
            }
        },
        inject: ['changeLoading'],
        props: {
            storeType: {
                default: () => '',
            },

        },
        data() {
            return {
                listLayout: '',
                filterLayout: '',
                paginationLayout: '',

                getFunc: '',
                listApiParamSet: {},
                pageRow: 10,

            }
        },
        created() {
            this.setFilterConfig(filterConfig)
            this.setParserType('url', this.$route.fullPath);
            this.initConfig();
        },
        mounted() {
            this.getList(true);
            EventBus.$on('getList', this.getList);
        },
        beforeDestroy() {
            EventBus.$off('getList')
        },
        destroyed() {},
        computed: {
        },
        methods: {
            setData(type, value) {
                this[type] = value;
            },
            initConfig() {
                let config = this.returnStoreConfig(this.storeType)
                this.listLayout= config.listLayout;
                this.filterLayout = config.filterLayout;
                this.paginationLayout = config.paginationLayout;
                this.getFunc = config.getFunc;
                this.listApiParamSet = config.listApiParamSet;

                let listOptions = {
                    url : this.$api.$store[this.getFunc],
                    defaultParams : this.listApiParamSet
                }
                this.initList('api', listOptions);
            },
        },
        watch: {},
    }
</script>

<style scoped>

</style>